import { useEffect } from 'react';

import { EventHandler, subscribe } from '../lib/observe';

export const useEventListener = (event: string, handler: EventHandler) => {
	useEffect(() => {
		return subscribe(event, handler);
	}, [event, handler]);
};
